<template>
    <text-dialog :title="$t('data_protection')" :download-link="downloadLink" :document-name="documentName">
        <slot name="activator" slot="activator"></slot>

        <span slot="content" v-t="'data_protection_text'"></span>
    </text-dialog>
</template>

<script>
    import TextDialog from '../dialogs/TextDialog';

    export default {
        data: () => ({
            downloadLink: '/static/pdf/data_protection.pdf',
            documentName: 'Datenschutz Einwilligung Eltern.pdf'
        }),
        components: {
            TextDialog
        }
    }
</script>